var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.0767 32.1523C36.2266 32.1523 40.2066 30.5038 43.1411 27.5693C46.0756 24.6348 47.7241 20.6548 47.7241 16.5049C47.7241 12.3549 46.0756 8.37493 43.1411 5.44046C40.2066 2.50599 36.2266 0.857422 32.0767 0.857422C27.9267 0.857422 23.9467 2.50599 21.0122 5.44046C18.0778 8.37493 16.4292 12.3549 16.4292 16.5049C16.4292 20.6548 18.0778 24.6348 21.0122 27.5693C23.9467 30.5038 27.9267 32.1523 32.0767 32.1523ZM42.5083 16.5049C42.5083 19.2715 41.4093 21.9249 39.4529 23.8812C37.4966 25.8375 34.8433 26.9365 32.0767 26.9365C29.31 26.9365 26.6567 25.8375 24.7004 23.8812C22.7441 21.9249 21.645 19.2715 21.645 16.5049C21.645 13.7382 22.7441 11.0849 24.7004 9.1286C26.6567 7.17229 29.31 6.07324 32.0767 6.07324C34.8433 6.07324 37.4966 7.17229 39.4529 9.1286C41.4093 11.0849 42.5083 13.7382 42.5083 16.5049ZM63.3716 58.2314C63.3716 63.4473 58.1558 63.4473 58.1558 63.4473H5.99756C5.99756 63.4473 0.781738 63.4473 0.781738 58.2314C0.781738 53.0156 5.99756 37.3682 32.0767 37.3682C58.1558 37.3682 63.3716 53.0156 63.3716 58.2314ZM58.1558 58.2106C58.1505 56.9275 57.3525 53.0678 53.8162 49.5315C50.4155 46.1307 44.0157 42.584 32.0767 42.584C20.1376 42.584 13.7378 46.1307 10.3371 49.5315C6.8008 53.0678 6.00799 56.9275 5.99756 58.2106H58.1558Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a2697bf1f459d522399d61085316223c.svg";
export { ForwardRef as ReactComponent };